import React from "react";


export const Backup = () => {

    return(
        <iframe src="https://wcs-smbdataprotection-manantialtecnologico.swcontentsyndication.com/Small-MediumBusinessDataProtection-Homepage-ES-LAT" style={{height: 4000, width: "100%", border: "none"}}></iframe>

    )
}